<div class="d-flex flex-column w-100">
	<label class="text-tertiary text-center fw-semibold mt-3 w-100">
		{{ tituloTabela }}
	</label>

	<div class="container-fluid px-0">
		<div
			class="d-flex my-3 flex-column flex-md-row justify-content-between align-items-start align-items-md-end gap-2">
			<seira-card-info class="w-100" [texto]="descricaoRelatorio" />
		</div>
		<label
			*ngIf="mensagemDataMinima"
			id="intervalo-dados-disponiveis"
			class="text-center w-100 mb-2">
			{{ mensagemDataMinima }}
		</label>

		<div
			*ngIf="carregando; else tabela"
			class="d-flex justify-content-center align-items-center w-100 h-50"
			style="min-height: 300px">
			<seira-loading [pageCentered]="false"></seira-loading>
		</div>

		<ng-template #tabela>
			<div class="table-responsive">
				<div class="mb-2">
					<seira-public-table
						#tabelaEvapotranspiracao
						id="tabela-evapotranspiracao"
						[hasFooter]="true"
						[hasHeader]="false"
						[info]="true"
						[paging]="true"
						[scrollX]="true"
						[searching]="false"
						[columns]="colunas"
						[data]="dadosTabelaEvapotranspiracao"></seira-public-table>
				</div>
			</div>
		</ng-template>
	</div>
</div>
